define("shared/components/shared/post/profile-selector/index", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "shared/components/shared/post/profile-selector/social-profile-state", "@ember/template-factory"], function (_exports, _component, _debug, _object, _service, _component2, _tracking, _socialProfileState, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/components/shared/post/profile-selector/social-profile-state",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! Available Profiles }}
  <Shared::Post::ProfileSelector::ProfileList
    @isAvailableList={{true}}
    @socialProfileStates={{this.socialProfileStates}}
    @toggleSelectProfile={{this.toggleSelectProfile}}
  />
  
  {{! Unavailable Profiles }}
  {{#if this.hasUnavailableProfiles}}
    <div class="cCP--listWrapper--dark">
      <Shared::Ui::Button
        @additional="block"
        @class={{concat-classes "u--text--bold u--text--light u--p__lr__sm" (if this.showUnavailableProfiles "is--open")}}
        @onClick={{this.toggleShowUnavailableProfiles}}
        @variant="unstyled"
        data-test-id="unavailable-profiles-toggle"
      >
        {{t "post.copy_post.modal.unavailable.title" count=this.numUnavailableProfiles}}
        {{svg-jar "nav-down" class="o--icon cCP--accordion__icon qa--modal_dropDown_icon"}}
      </Shared::Ui::Button>
  
      {{#if this.showUnavailableProfiles}}
        <div data-test-id="collapsable-profiles-content">
          <Shared::Post::ProfileSelector::ProfileList
            @closeAction={{@closeAction}}
            @isAvailableList={{false}}
            @socialProfileStates={{this.socialProfileStates}}
          />
        </div>
      {{/if}}
    </div>
  {{/if}}
  */
  {
    "id": "706u14uN",
    "block": "[[[8,[39,0],null,[[\"@isAvailableList\",\"@socialProfileStates\",\"@toggleSelectProfile\"],[true,[30,0,[\"socialProfileStates\"]],[30,0,[\"toggleSelectProfile\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"hasUnavailableProfiles\"]],[[[1,\"  \"],[10,0],[14,0,\"cCP--listWrapper--dark\"],[12],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"unavailable-profiles-toggle\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",[28,[37,3],[\"u--text--bold u--text--light u--p__lr__sm\",[52,[30,0,[\"showUnavailableProfiles\"]],\"is--open\"]],null],[30,0,[\"toggleShowUnavailableProfiles\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"post.copy_post.modal.unavailable.title\"],[[\"count\"],[[30,0,[\"numUnavailableProfiles\"]]]]]],[1,\"\\n      \"],[1,[28,[35,5],[\"nav-down\"],[[\"class\"],[\"o--icon cCP--accordion__icon qa--modal_dropDown_icon\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showUnavailableProfiles\"]],[[[1,\"      \"],[10,0],[14,\"data-test-id\",\"collapsable-profiles-content\"],[12],[1,\"\\n        \"],[8,[39,0],null,[[\"@closeAction\",\"@isAvailableList\",\"@socialProfileStates\"],[[30,1],false,[30,0,[\"socialProfileStates\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@closeAction\"],false,[\"shared/post/profile-selector/profile-list\",\"if\",\"shared/ui/button\",\"concat-classes\",\"t\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/post/profile-selector/index.hbs",
    "isStrictMode": false
  });
  let ProfileSelectorComponent = _exports.default = (_class = class ProfileSelectorComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "showUnavailableProfiles", _descriptor4, this);
      (false && !(typeof args.post === 'object') && (0, _debug.assert)('Must pass post to Post::ProfileSelector', typeof args.post === 'object'));
      this.socialProfiles.forEach(profile => {
        const isSelected = this.args.initialSelection?.includes(profile.id);
        const profileState = new _socialProfileState.default(profile, this.args.post, isSelected);
        this.socialProfileStates.push(profileState);
      });
    }
    get socialProfileStates() {
      return this.args.socialProfileStates;
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get hasUnavailableProfiles() {
      return this.numUnavailableProfiles > 0;
    }
    get numUnavailableProfiles() {
      return this.socialProfileStates.filter(state => {
        return !state.isAvailable;
      }).length;
    }
    get selectedProfiles() {
      return this.socialProfileStates.filter(state => state.isAvailable && state.isSelected);
    }
    get socialProfiles() {
      return this.currentGroup.socialProfiles;
    }
    get maxSelectedProfiles() {
      return this.args.maxSelectedProfiles;
    }
    get selectedProfilesExceedMax() {
      if (!this.maxSelectedProfiles) {
        return false;
      }
      return this.selectedProfiles.length >= this.maxSelectedProfiles;
    }
    toggleSelectProfile(state) {
      // Note: we are trying to select more than maxSelectedProfiles
      if (this.selectedProfilesExceedMax && !state.isSelected) {
        // Note: do not allow this profile to be selected
        if (this.args.alertMaxSelectedProfiles) {
          return this.alerts.warning(this.intl.t('alerts.profile_selector.max_selected.description', {
            count: this.maxSelectedProfiles
          }), {
            title: this.intl.t('alerts.profile_selector.max_selected.title', {
              count: this.maxSelectedProfiles
            }),
            preventDuplicates: true,
            sticky: false
          });
        }

        // Note: replace one of the selected profiles with the new one
        this.socialProfileStates.find(state => state.isAvailable && state.isSelected)?.toggleSelect();
      }
      state.toggleSelect();
    }
    toggleShowUnavailableProfiles() {
      this.showUnavailableProfiles = !this.showUnavailableProfiles;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showUnavailableProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSelectProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelectProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleShowUnavailableProfiles", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowUnavailableProfiles"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileSelectorComponent);
});